module.exports = __webpack_public_path__ + "img/taxi-ne.1cfb7ed0.png";